<template>
  <div class="search-item">
    <span class="search-label">{{ label }}</span>
    <el-input 
      v-if="type === 'input'"
      :value="value"
      :placeholder="placeholder"
      :maxlength="maxlength"
      clearable
      @input="$emit('input', $event)">
    </el-input>
    <el-date-picker 
      v-else-if="type === 'daterange'"
      :value="value"
      type="daterange" 
      range-separator="至"
      start-placeholder="开始日期" 
      end-placeholder="结束日期" 
      :clearable="true"
      @input="$emit('input', $event)">
    </el-date-picker>
    <el-select 
      v-else-if="type === 'select'"
      :value="value"
      :placeholder="placeholder"
      clearable
      @input="$emit('input', $event)">
      <el-option 
        v-for="option in options" 
        :key="option.value" 
        :label="option.label" 
        :value="option.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'SearchItem',
  props: {
    label: String,
    type: { type: String, default: 'input' },
    placeholder: String,
    maxlength: Number,
    value: [String, Array],
    options: { type: Array, default: () => [] }
  }
}
</script>

<style scoped>
.search-item {
  display: flex;
  align-items: center;
  min-width: 280px;
  flex: 1;
}

.search-label {
  display: inline-block;
  width: 80px;
  text-align: right;
  margin-right: 10px;
  font-size: 14px;
  color: #606266;
  font-weight: 500;
  flex-shrink: 0;
}

.search-item .el-input,
.search-item .el-date-picker,
.search-item .el-select {
  width: 200px;
}
</style>